module.exports = __webpack_public_path__ + "static/media/lamp.4d8bcea3.svg";